export const SUNDAY = 'SU';
export const MONDAY = 'MO';
export const TUESDAY = 'TU';
export const WEDNESDAY = 'WE';
export const THURSDAY = 'TH';
export const FRIDAY = 'FR';
export const SATURDAY = 'SA';
